import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import header from './core/header';
import footer from './core/footer';
import stepper from './core/stepper';
import builderRequireAuthModal from './builder/builder-require-auth-modal';
import builderActions from './builder/builder-actions';
import builderGenerateButton from './builder/builder-generate-button';
import builderDownloadDataButton from './builder/builder-download-data-button';
import builderDebuggger from './builder/builder-debugger';
import relationshipList from './builder/relationship/relationship-list';
import entityList from './builder/entity/entity-list';
import fieldList from './builder/field/field-list';
import propertyForm from './builder/property/property-form';
import entityFormBasic from './builder/entity/entity-form-basic';
import entityFormProperty from './builder/entity/entity-form-property';
import fieldFormBasic from './builder/field/field-form-basic';
import fieldFormProperty from './builder/field/field-form-property';
import fieldFormRelation from './builder/field/field-form-relation';
import fieldValidationForm from './builder/field/field-validation-form';
import fieldValidationList from './builder/field/field-validation-list';
import projectFileExplorer from './project/project-file-explorer';
import projectLabelEdit from './project/project-label-edit';
import projectDownloadActions from './project/project-download-actions';
import purchaseModal from './credits/purchase-modal';
import activationCodeModal from './pricing/activation-code-modal';
import notFound from './core/not-found';
import pricingModal from './pricing/pricing-modal.vue';
import layout from './core/layout';

Vue.component('vue-markdown', VueMarkdown);
Vue.component('app-footer', footer);
Vue.component('app-header', header);
Vue.component('app-builder-actions', builderActions);
Vue.component(
  'app-builder-generate-button',
  builderGenerateButton,
);
Vue.component(
  'app-builder-download-data-button',
  builderDownloadDataButton,
);
Vue.component('app-builder-debugger', builderDebuggger);
Vue.component('app-property-form', propertyForm);
Vue.component('app-relationship-list', relationshipList);
Vue.component('app-entity-list', entityList);
Vue.component('app-entity-form-basic', entityFormBasic);
Vue.component(
  'app-entity-form-property',
  entityFormProperty,
);
Vue.component('app-field-list', fieldList);
Vue.component('app-field-form-basic', fieldFormBasic);
Vue.component('app-field-form-property', fieldFormProperty);
Vue.component('app-field-form-relation', fieldFormRelation);
Vue.component('app-pricing-modal', pricingModal);
Vue.component(
  'app-field-validation-form',
  fieldValidationForm,
);
Vue.component(
  'app-field-validation-list',
  fieldValidationList,
);
Vue.component(
  'app-project-file-explorer',
  projectFileExplorer,
);
Vue.component(
  'app-project-download-actions',
  projectDownloadActions,
);
Vue.component('app-stepper', stepper);
Vue.component(
  'app-builder-require-auth-modal',
  builderRequireAuthModal,
);
Vue.component(
  'app-activation-code-modal',
  activationCodeModal,
);
Vue.component('app-purchase-modal', purchaseModal);
Vue.component('app-not-found', notFound);
Vue.component('app-project-label-edit', projectLabelEdit);
Vue.component('app-layout', layout);

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.eventSetDrag = function() {
      el.setAttribute('data-dragging', 'yes');
    };
    el.eventClearDrag = function() {
      el.removeAttribute('data-dragging');
    };
    el.eventOnClick = function(event) {
      var dragging = el.getAttribute('data-dragging');
      // Check that the click was outside the el and its children, and wasn't a drag
      if (
        !(
          el == event.target || el.contains(event.target)
        ) &&
        !dragging
      ) {
        // call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.addEventListener(
      'touchstart',
      el.eventClearDrag,
    );
    document.addEventListener('touchmove', el.eventSetDrag);
    document.addEventListener('click', el.eventOnClick);
    document.addEventListener('touchend', el.eventOnClick);
  },
  unbind: function(el) {
    document.removeEventListener(
      'touchstart',
      el.eventClearDrag,
    );
    document.removeEventListener(
      'touchmove',
      el.eventSetDrag,
    );
    document.removeEventListener('click', el.eventOnClick);
    document.removeEventListener(
      'touchend',
      el.eventOnClick,
    );
    el.removeAttribute('data-dragging');
  },
});
